import { useContext } from 'react';
import FeedbackContext from './FeedbackContext';

export const useFeedback = () => {
  return useContext(FeedbackContext);
};

export default useFeedback;
